import { getChkval } from './md5.js';

export const addCheckParams = (config) => {
  const timestamp = Math.ceil(new Date().getTime() / 1000);
  config.headers.sign = getChkval(config, timestamp);
  config.headers.timestamp = timestamp;
  console.log('addCheckParams before return', config);
  return config;
};

export default { addCheckParams };

//
